"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _xLicense = require("@ori-ui/mui-x-bundle/x-license");
// license expiration date: 2025-06-21

const applyLicense = () => _xLicense.LicenseInfo.setLicenseKey('45effd61e6ee8878d67d8bd9b2eaf43bTz0xMTI2NDYsRT0xNzgwMDk5MTk5MDAwLFM9cHJvLExNPXBlcnBldHVhbCxQVj0yMDIyLEtWPTI=');
var _default = exports.default = applyLicense;
